import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import * as types from './types';
import { fetchCustomer as _fetchCustomer, addCart as _addCart, addCartCustomizable as _addCartCustomizable, updateCart as _updateCart } from '~/services/customer';
export default {
  fetchCustomer: function () {
    var _fetchCustomer2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 3;
              return _fetchCustomer(this);

            case 3:
              data = _context.sent;
              commit(types.SET_CUSTOMER, data);
              commit(types.SET_CART, data);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchCustomer(_x) {
      return _fetchCustomer2.apply(this, arguments);
    }

    return fetchCustomer;
  }(),
  addCart: function () {
    var _addCart2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref2, payload) {
      var commit, data, qty, pdtData;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.next = 3;
              return _addCart(this, payload);

            case 3:
              data = _context2.sent;
              commit(types.PUSH_CART, payload);
              qty = data.split('|').find(function (a) {
                return a.includes('item_qty');
              });
              qty = qty ? qty.replace('item_qty:', '') : 0;
              pdtData = {
                quantity: parseInt(qty, 10) || 0,
                reference: payload.reference
              };
              commit(types.SET_CURRENT_ITEM_QTY, pdtData);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function addCart(_x2, _x3) {
      return _addCart2.apply(this, arguments);
    }

    return addCart;
  }(),
  addCartCustomizable: function () {
    var _addCartCustomizable2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref3, payload) {
      var commit, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              _context3.next = 3;
              return _addCartCustomizable(this, payload);

            case 3:
              data = _context3.sent;

              if (data.success) {
                commit(types.PUSH_CART, {
                  quantity: 1
                });
                commit(types.SET_CART_SUCCESS, true);
              } else {
                commit(types.SET_CART_SUCCESS, false);
              }

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function addCartCustomizable(_x4, _x5) {
      return _addCartCustomizable2.apply(this, arguments);
    }

    return addCartCustomizable;
  }(),
  updateCart: function () {
    var _updateCart2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(_ref4, payload) {
      var commit, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              _context4.next = 3;
              return _updateCart(this, payload);

            case 3:
              data = _context4.sent;
              commit(types.SET_CART, {
                cart: data.cartItem
              });
              commit(types.SET_CURRENT_ITEM_QTY, payload);

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function updateCart(_x6, _x7) {
      return _updateCart2.apply(this, arguments);
    }

    return updateCart;
  }()
};